import { C } from "../../../../constants";
import { daysUntil, getPhaseProgress } from "../../../../utils";

function TaskMini({ task, onDone, StatusChip, DepartmentBadge }) {
  const isOverdue = daysUntil(task.dueDate) < 0 && task.status !== "Done";
  const isBlocked = task.status === "Blocked";
  const dueStyle = isOverdue ? { color: C.red } : daysUntil(task.dueDate) <= 3 ? { color: C.yellow } : { color: C.dim };

  return (
    <div className="tmini" style={isBlocked ? { borderLeft: `2px solid ${C.yellow}` } : isOverdue ? { borderLeft: `2px solid ${C.red}` } : {}}>
      <StatusChip status={task.status} />
      <div className="tmini-title">{task.title}</div>
      <DepartmentBadge dept={task.department} />
      {task.assignee && <span className="tmini-assignee">{task.assignee.split(" ")[0]}</span>}
      <span className="tmini-due mono" style={dueStyle}>{task.dueDate}</span>
      <div className="tact">
        {task.status !== "Done" && <button className="tbtn tbtn-done" onClick={(event) => { event.stopPropagation(); onDone(task.taskId); }}>✓</button>}
      </div>
    </div>
  );
}

export default function WorkflowDrawer({ projectId, tasks, onDone, colSpan, StatusChip, DepartmentBadge }) {
  const projectTasks = tasks.filter((task) => task.projectId === projectId);
  const phases = getPhaseProgress(projectTasks);
  const blockers = projectTasks.filter((task) => task.status === "Blocked" || (daysUntil(task.dueDate) < 0 && task.status !== "Done" && task.status !== "Cancelled"));

  return (
    <tr className="drawer-row">
      <td colSpan={colSpan}>
        <div className="drawer-inner">
          {blockers.length > 0 && (
            <div className="blocker-list">
              {blockers.map((blocker) => (
                <div key={blocker.taskId} className="blocker-card blocker-item">
                  <div className="blocker-title">{blocker.status === "Blocked" ? "🔴 Blocked" : "⚠ Overdue"}: {blocker.title}</div>
                  <div className="blocker-meta"><DepartmentBadge dept={blocker.department} /> · {blocker.assignee || "Unassigned"} · Due {blocker.dueDate}</div>
                </div>
              ))}
            </div>
          )}
          {phases.map((phase) => {
            const phaseTasks = projectTasks.filter((task) => task.phaseId === phase.id && task.status !== "Cancelled");
            return (
              <div className="phase-block" key={phase.id}>
                <div className="phase-head">
                  <span className="phase-name">{phase.name}</span>
                  <div className="phase-head-meta">
                    <div className="phase-pbar"><div className="phase-pfill" style={{ width: `${phase.pct}%` }} /></div>
                    <span className="phase-ppct">{phase.pct}%</span>
                  </div>
                </div>
                {phaseTasks.map((task) => <TaskMini key={task.taskId} task={task} onDone={onDone} StatusChip={StatusChip} DepartmentBadge={DepartmentBadge} />)}
              </div>
            );
          })}
        </div>
      </td>
    </tr>
  );
}
